import React from 'react';
import Modal from 'react-responsive-modal';
import { closeIconPath } from 'containers/modals/ModalRoot';
import useModal from './useModal';
import GroupForm from './GroupForm';
import SubGroupForm from './SubGroupForm';
import CohortForm from './CohortForm';

const SaveModal = () => {
  const { opened, group, subgroup, cohort, closeModal } = useModal();

  return (
    <Modal
      classNames={{ overlay: 'o-modal__wrap', modal: 'o-modal o-modal__min-height row column u-margin-top--large' }}
      closeIconSvgPath={closeIconPath()}
      closeOnOverlayClick={true}
      open={opened}
      onClose={closeModal}
      center
    >
      {opened === 'group' && <GroupForm group={group} />}
      {opened === 'subgroup' && <SubGroupForm group={group} subgroup={subgroup} />}
      {opened === 'cohort' && <CohortForm group={group} subgroup={subgroup} cohort={cohort} />}
    </Modal>
  )
}

export default SaveModal;
